G.TimerT = function(x,y,date,style,anchor,maxWidth,timerFormat,sfx) {
	
	G.Text.call(this,x,y,'???',style,anchor,maxWidth);

	this.secLeft = 0;
	this.active = false;
	this.timerFormat = timerFormat;

	this.dots = true;

	this.sfx = sfx ? G.sfx[sfs] : null;

	this.timerBinding = G.sb('onWallClockTimeUpdate').add(this.updateTimer,this);

	this.events.onDestroy.add(function() {
		this.timerBinding.detach();
	},this);

	if (date){
		this.setDate(date);
	}

}

G.TimerT.prototype = Object.create(G.Text.prototype);


G.TimerT.prototype.updateTimer = function() {

	if (!this.active) return;

	if (this.sfx) this.sfx.play();
	
	this.secLeft = Math.max(0,this.secLeft-1);

	this.updateTimerText(this.secLeft,this.dots);

	this.dots = !this.dots;

	// var dataArray = G.changeSecToDHMS(this.secLeft);

	// this.setText(G.changeSecToTimerFormat(this.secLeft));

};

G.TimerT.prototype.setSecLeft = function(secLeft) {

	this.secLeft = Math.max(0,secLeft);
	this.updateTimerText(this.secLeft,true);

};

G.TimerT.prototype.updateTimerText = function(secLeft,dots){

	var dataArray = G.changeSecToDHMS(this.secLeft);

	var txt = [];

	if (this.timerFormat.indexOf('d') > -1){
		txt.push(dataArray[0]);
	}

	if (this.timerFormat.indexOf('h') > -1){
		txt.push(dataArray[1]);
	}

	if (this.timerFormat.indexOf('m') > -1){
		txt.push(dataArray[2]);
	}

	if (this.timerFormat.indexOf('s') > -1){
		txt.push(dataArray[3]);
	}

	this.setText(txt.join(dots ? ':' : ' '));

};

G.TimerT.prototype.start = function(secLeft) {

	this.active = true;

};

G.TimerT.prototype.setDate = function(dateString){

	var ms = new Date(dateString).getTime();
	var now = Date.now();
	var diffSec = Math.ceil((ms-now)/1000);
	this.setSecLeft(diffSec);
	this.active = true;

};